import { render } from "./Blog_Details.vue?vue&type=template&id=4cc0f87f&scoped=true&ts=true"
import script from "./Blog_Details.vue?vue&type=script&lang=ts"
export * from "./Blog_Details.vue?vue&type=script&lang=ts"

import "./Blog_Details.vue?vue&type=style&index=0&id=4cc0f87f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cc0f87f"]])

export default __exports__